exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-prodi-add-tsx": () => import("./../../../src/pages/prodi-add.tsx" /* webpackChunkName: "component---src-pages-prodi-add-tsx" */),
  "component---src-pages-prodi-edit-tsx": () => import("./../../../src/pages/prodi-edit.tsx" /* webpackChunkName: "component---src-pages-prodi-edit-tsx" */),
  "component---src-pages-prodi-tsx": () => import("./../../../src/pages/prodi.tsx" /* webpackChunkName: "component---src-pages-prodi-tsx" */)
}

